<template>
  <div
    :class="wrapClass"
  >
    <div :class="modeClass" :style="styles">

      <!-- 左按钮 -->
      <div v-if="mode" :class="previousArrowClass" @click="scrollLeft">
        <t-icon v-if="mode==='scrollX'" icon="chevron-left-outline"></t-icon>
        <t-icon v-if="mode==='scrollY'" icon="chevron-up-outline"></t-icon>
      </div>

      <!-- tab项 -->
      <div :class="prefix+'-list__content'">
        <ul ref="tabsNav" :class="prefix+'-list__nav'" :style="scrollStyle">
          <li v-for="(tab,index) in list$" :key="index" :class="[prefix+'-tab', {checked:index === currentChecked}]" :disabled="tab.disabled" @click="$_change(index, false)">
            <t-icon v-if="tab.icon" :icon="tab.icon"></t-icon>
            {{ tab.label }}
            <t-icon v-if="closeable$" icon="close" @click.native.stop="$_remove(index, false)"></t-icon>
          </li>
        </ul>
      </div>

      <!-- 右按钮 -->
      <div v-if="mode" :class="backArrowClass" @click="scrollRight">
        <t-icon v-if="mode==='scrollX'" icon="chevron-right-outline"></t-icon>
        <t-icon v-if="mode==='scrollY'" icon="chevron-down-outline"></t-icon>
      </div>

      <!-- 超出threshold部分,显示在下拉菜单 -->
      <t-dropdown v-if="showRest" trigger-mode="click" :class="prefix+'-list__more'">
        <t-icon slot="trigger" icon="dots-horizontal"></t-icon>
        <div slot="popper">
          <div :class="gprefix+'list'">
            <ul :class="gprefix+'list__options'">
              <li
                v-for="(tab,index) in rest$"
                :key="index"
                :checked="tab.panelId === activeName"
                :class="gprefix+'list__item'"
                href="javascript:void(0)"
                @click="$_change(index, true)"
              >{{ tab.label }}
                <t-icon v-if="closeable$" icon="close" @click.native.stop="$_remove(index, true)"></t-icon>
              </li>
            </ul>
          </div>
        </div>
      </t-dropdown>

      <div :class="prefix+'-list__extra'">
        <slot name="extra"></slot>
      </div>
    </div>

    <div :class="contentClass" :style="contentStyle">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { isPInt } from '../../utils/assist'
import Locale from '../../mixins/locale'
import clickoutside from '../../directives/click-outside'
import { PREFIX_CLASS } from '@/utils/constants'

export default {
  name: 'TTabs',
  directives: { clickoutside },
  mixins: [Locale],
  props: {
    value: {
      type: String,
      default: ''
    },
    tabsAlign: {
      type: String,
      default: 'left'
    },
    type: {
      type: String,
      default: '',
      validator(val) {
        return ['', 'card'].indexOf(val) > -1
      }
    },
    animated: {// 动画效果
      type: Boolean,
      default: true
    },
    mode: {
      type: String,
      default: '',
      validator(val) {
        return ['', 'scrollX', 'scrollY'].indexOf(val) > -1
      }
    },
    orientation: {
      type: String,
      default: 'horizontal',
      validator(value) {
        return ['horizontal', 'vertical'].includes(value)
      }
    },
    width: {
      type: String,
      default: ''
    },
    closeable: {
      type: Boolean,
      default: false
    },
    threshold: {
      type: Number,
      default: -1,
      validator: value => isPInt(value) || value === -1
    },
    beforeChange: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      gprefix: PREFIX_CLASS,
      prefix: PREFIX_CLASS + 'tabs',
      activeName: '',
      activeIndex: -1,
      dropdownActive$: false,
      list$: [],
      rest$: [],
      showRest: false,
      closeable$: this.closeable,
      scrollDistance: 0,
      currentChecked: 0,
      backArrowDisabled: false
    }
  },
  computed: {
    wrapClass() {
      return {
        [`${this.prefix}`]: true,
        [`${this.prefix}--center`]: this.tabsAlign === 'center',
        [`${this.prefix}--card`]: this.type === 'card',
        [`${this.prefix}--vertical ${this.prefix}--text-right`]: this.orientation === 'vertical'
      }
    },
    contentClass() {
      return [
        `${this.prefix}-content`,
        {
          [`${this.prefix}-content--animated`]: this.animated
        }
      ]
    },
    contentStyle() {
      if (this.animated) {
        let activeIndex = this.activeIndex
        let translate = this.orientation === 'horizontal' ? 'translateX' : 'translateY'
        let move = activeIndex !== -1 ? (-activeIndex * 100) : 0
        return {
          transform: `${translate}(${move}%)`
        }
      }
      return {}
    },
    styles() {
      let style = {}
      if (this.orientation === 'vertical') style.width = this.width
      return style
    },
    scrollStyle() {
      let style = {}
      if (this.mode === 'scrollX') {
        style.transform = `translate3d(${this.scrollDistance}px, 0px, 0px)`
      }
      if (this.mode === 'scrollY') {
        style.transform = `translate3d(0px, ${this.scrollDistance}px, 0px)`
      }
      return style
    },
    modeClass() {
      return [
        `${this.prefix}-list`,
        {
          [`${this.mode}`]: this.mode
        }
      ]
    },
    previousArrowClass() {
      return {
        [`${this.prefix}-list__btn ${this.prefix}-list__btn--prev`]: true,
        'disabled': this.scrollDistance === 0
      }
    },
    backArrowClass() {
      return {
        [`${this.prefix}-list__btn ${this.prefix}-list__btn--next`]: true,
        'disabled': this.backArrowDisabled
      }
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        this.activeName = newVal
      },
      immediate: true
    },
    activeName(val) {
      this.$_updateActiveIndex()
      this.$_updatePanels()
    },
    threshold(val, oldVal) {
      if (val > 0 && val !== oldVal) {
        this.update()
      }
    },
    list$(val) {
      if (this.closeable) {
        if (val.length === 1) {
          this.closeable$ = false
        } else {
          this.closeable$ = true
        }
      }
    }
  },
  created() {
    this.$on('tabs-refresh', () => {
      this.getTabsAndUpdate()
    })
  },

  methods: {
    getStyle(ele) {
      var style = null
      if (window.getComputedStyle) {
        style = window.getComputedStyle(ele, null)
      } else {
        style = ele.currentStyle
      }
      return style
    },
    scrollLeft() {
      if (this.scrollDistance === 0) return
      this.backArrowDisabled = false
      let tabsNav = this.$refs.tabsNav
      if (tabsNav) {
        let parent = this.getStyle(tabsNav.parentNode)
        if (this.mode === 'scrollX') {
          this.scrollDistance = this.scrollDistance + parseInt(parent.width.replace(/px/ig, ''))
        }
        if (this.mode === 'scrollY') {
          this.scrollDistance = this.scrollDistance + parseInt(parent.height.replace(/px/ig, ''))
        }
      }
    },
    scrollRight() {
      if (this.backArrowDisabled) return
      let tabsNav = this.$refs.tabsNav
      let domHeight = this.getStyle(tabsNav).height
      if (tabsNav) {
        let parent = this.getStyle(tabsNav.parentNode)
        if (this.mode === 'scrollX') {
          this.scrollDistance = this.scrollDistance - parent.width.replace(/px/ig, '')
        }
        if (this.mode === 'scrollY') {
          this.scrollDistance = this.scrollDistance - parent.height.replace(/px/ig, '')
        }
        // tabs-list__btn--next 按钮置灰
        this.backArrowDisabled = parseInt(parent.height.replace(/px/ig, '')) - this.scrollDistance >= parseInt(domHeight.replace(/px/ig, ''))
      }
    },
    getTabsAndUpdate() {
      this.list$ = this.$_getTabs().map((v, i) => {
        return {
          label: v.label,
          icon: v.icon || '',
          panelId: v.panelId || i,
          disabled: v.disabled,
          index: i
        }
      })
      this.update()
    },
    update() {
      if (this.list$.length > this.threshold && this.threshold > 0) {
        this.showRest = true
        this.rest$ = this.list$.slice(this.threshold)
        this.list$ = this.list$.slice(0, this.threshold)
      }
      if (this.activeName) {
        this.$_updateActiveIndex()
        this.$_updatePanels()
      } else {
        if (this.list$.length > 0) {
          this.activeName = this.list$[0].panelId
        }
      }
    },

    $_getActiveIndexByName(activeName) {
      let tabPanels = this.$children.filter(item => {
        return item.panelId
      })
      for (let i = tabPanels.length - 1; i >= 0; i--) {
        if (tabPanels[i].panelId === activeName) {
          return i
        }
      }
    },
    $_updateActiveIndex() {
      this.activeIndex = this.$_getActiveIndexByName(this.activeName)
      this.currentChecked = this.activeIndex
    },
    $_updatePanels() {
      const tabs = this.$_getTabs()
      tabs.forEach(tab => {
        tab.show$ = tab.panelId === this.activeName
      })
    },
    // 获取所有的tab对象
    $_getTabs() {
      return this.$children.filter(
        v => v.$options._componentTag === 't-tab-panel'
      )
    },
    $_change(index, isRest) {
      const tab = isRest ? this.rest$[index] : this.list$[index]
      if (tab.disabled) {
        return
      }
      let oldName = this.activeName
      let oldIndex = this.activeIndex
      let newIndex = this.$_getActiveIndexByName(tab.panelId)
      if (this.beforeChange !== null && this.beforeChange(tab.panelId, newIndex, oldName, oldIndex) === false) {
        return
      }
      this.activeName = tab.panelId
      this.activeIndex = newIndex
      this.currentChecked = isRest ? index + this.threshold : index
      this.$emit('input', this.activeName)
      this.$emit(
        'change',
        this.activeName,
        this.activeIndex,
        oldName,
        oldIndex
      )
    },
    $_remove(index, isRest) {
      const tab = isRest ? this.rest$[index] : this.list$[index]
      this.$_getTabs().forEach(v => {
        if (v.panelId === tab.panelId) {
          v.$el.parentNode.removeChild(v.$el)
          v.$destroy()
        }
      })
      // 当移除的是被选中的tab选择新的tab为选中状态
      if (tab.panelId === this.activeName) {
        const newTabs = this.list$.filter(v => !v.disabled)
        const rightNoDisabled = this.list$.filter(
          (v, i) => !v.disabled && i > index
        )
        const leftNoDisabled = this.list$.filter(
          (v, i) => !v.disabled && i < index
        )
        if (rightNoDisabled.length) {
          this.activeName = rightNoDisabled[0].panelId
        } else if (leftNoDisabled.length) {
          this.activeName = leftNoDisabled[0].panelId
        } else {
          this.activeName = newTabs.length > 0 ? newTabs[0].panelId : ''
        }
        this.$_updateActiveIndex()
      }
      if (isRest) {
        this.rest$.splice(index, 1)
      } else {
        this.list$.splice(index, 1)
      }
      if (
        this.list$.length < this.threshold &&
        this.threshold > 0 &&
        this.rest$.length > 0
      ) {
        this.list$.push(this.rest$[0])
        this.rest$ = this.rest$.slice(1)
      }
      if (this.list$.length + this.rest$.length <= this.threshold) {
        this.showRest = false
      } else {
        this.showRest = true
      }
      this.$emit('remove', index, tab.panelId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/tabs/tabs.vue